import "./UpgradeTriggerModal.css";
import { useNavigate } from "react-router-dom";

function UpgradeTriggerModal({ onClose }) {
  const navigate = useNavigate();

  return (
    <div className="upgrade-trigger-overlay" onClick={onClose}>
      <div 
        className="upgrade-trigger-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="upgrade-trigger-header">
          <div className="celebration-icon">🎉</div>
          <h2>Phase 1 Mastered!</h2>
          <p className="subtitle">You've successfully completed the foundation of this track.</p>
        </div>

        <div className="upgrade-trigger-content">
          <div className="value-proposition">
            <h3>Ready for the real challenge?</h3>
            <p>Phase 2 and beyond contain advanced projects, real-world complexity, and the skills that get you hired.</p>
            
            <ul className="perks-list">
              <li><span>🚀</span> Advanced Case Studies</li>
              <li><span>🛠️</span> Industry-Standard Projects</li>
              <li><span>📈</span> Master-Level Assessments</li>
              <li><span>📜</span> Track-Based Certification</li>
            </ul>
          </div>
        </div>

        <div className="upgrade-trigger-footer">
          <button className="upgrade-now-btn" onClick={() => navigate("/upgrade")}>
            Unlock Full Track Access
          </button>

          <div className="upgrade-referral-option">
            <p>Short on cash?</p>
            <button className="refer-instead-btn" onClick={() => navigate("/profile#referral")}>
              Unlock Phase 2 for FREE by referring 1 friend →
            </button>
          </div>

          <button className="later-btn" onClick={onClose}>
            I'll upgrade later
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradeTriggerModal;
